<template>
  <div class="checkin">
    <div class="checkin__top" @click="showChecking">
      <div v-if="isMobile">
        <div class="checkin__top__container">
          <span class="icon-Icon-Calendar" />
          <div>
            {{ bookingData.checkIn ? getCheckinDate : $t("booking.select") }} -
            {{ bookingData.checkOut ? getCheckoutDate : $t("booking.select") }}
          </div>
        </div>
      </div>

      <div v-else>
        <div class="checkin__top__title" :class="{ 'active-title': isActive }">
          <div>{{ $t("booking.check_in") }}</div>

          <div>{{ $t("booking.check_out") }}</div>
        </div>

        <div
          class="checkin__top__container"
          :class="{ 'calender-active': isShowChecking }"
        >
          <div class="date-item booking-checkin" @click="setStartDate">
            <span class="icon-Icon-Calendar" />

            <div class="date">
              {{ bookingData.checkIn ? getCheckinDate : $t("booking.select") }}
            </div>
          </div>

          <span class="icon-Arrow-Thin-Right" />

          <div class="date-item" @click="setEndDate">
            <span class="icon-Icon-Calendar" />

            <div class="date">
              {{
                bookingData.checkOut ? getCheckoutDate : $t("booking.select")
              }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="checkin__bottom">
      <div
        class="checkin__bottom__container"
        :class="{
          'checkin__bottom__container-with-hotel-select': isShowHotelSelect,
        }"
      >
        <div v-if="isShowChecking">
          <Calendar
            ref="calendarComponent"
            :invalid-date="invalidDate"
            :minimum-stay="minimumStay"
            :container="'checkin'"
            :hotel-code="hotelCode"
            :sub-container="'checkin__bottom__container'"
            :lang="lang"
            :inner-height="innerHeight"
            :isShowInventory="isShowInventory"
            @clickDoneBtn="closeAll"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState, mapGetters } from "vuex";
import Calendar from "./Calendar";

export default Vue.extend({
  name: "Checkin",
  props: {
    isActive: {
      type: Boolean,
    },
    lang: {
      type: String,
    },
    hotelCode: {
      type: String,
    },
    isShowInventory: {
      type: Boolean,
      default: false,
    },
    isShowHotelSelect: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Calendar,
  },
  data: () => {
    return {
      isSetEndDate: false,
      isSetStartDate: false,
      invalidDate: [
        { start: new Date("2020-07-07"), end: new Date("2020-07-08") },
      ],
      minimumStay: [{ d: new Date(2020, 5, 4) }, { d: new Date(2020, 5, 5) }],
    };
  },
  computed: {
    ...mapGetters({
      getCheckinDate: "getCheckinDate",
      getCheckoutDate: "getCheckoutDate",
      isMobile: "isMobile",
    }),
    ...mapState({
      bookingData: (state) => state.bookingData,
      isShowChecking: (state) => state.bookingState.checking,
    }),
  },
  watch: {
    language: {
      deep: true,
      handler() {
        this.getBooking();
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.innerHeight = window.innerHeight;
    });
  },
  methods: {
    ...mapActions({
      showChecking: "showChecking",
      showRoomSelect: "showRoomSelect",
      showTotalGuest: "showTotalGuest",
      getCheckin: "getCheckin",
      getCheckout: "getCheckout",
      closeAll: "closeAll",
      getBooking: "getInitialBooking",
    }),
    setStartDate() {
      if (this.$refs.calendarComponent) {
        this.$refs.calendarComponent.datePicker("start");
      }
    },
    setEndDate() {
      if (this.$refs.calendarComponent) {
        this.$refs.calendarComponent.datePicker("end");
      }
    },
  },
});
</script>
<style scoped lang="scss">
.checkin {
  width: 100%;
  margin-bottom: 20px;
  position: relative;
  @include min-sm {
    flex-basis: 42%;
  }
  @include min-sm {
    width: fit-content;
    min-width: 204px;
    margin-bottom: 0;
    flex-basis: auto;
  }
  &__top {
    position: relative;
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 13px;
      margin-bottom: 12px;
      padding: 0 15px;
      white-space: nowrap;

      & > div {
        width: 45%;
        text-align: center;
      }
    }

    &__container {
      display: flex;
      align-items: center;
      padding: 15px;
      width: 100%;
      background: white;
      border: 2px solid #dddee0;
      font-size: 14px;
      line-height: 16px;
      color: #232e48;
      // font-weight: 500;
      // position: relative;
      cursor: pointer;
      span {
        font-size: 16px;
        margin-right: 15px;
      }
      &::before {
        content: "";
        right: 3px;
        bottom: 3px;
        position: absolute;
        width: 0;
        height: 0;
        border: 5px solid transparent;
        border-top: 5px solid #ffd25d;
        border-right: 5px solid #ffd25d;
        -webkit-transform: rotate(90deg);
        transform: rotate(90deg);
      }
      @include min-sm {
        &::after {
          content: "";
          opacity: 0;
          visibility: hidden;
          right: 50%;
          width: 20px;
          height: 20px;
          background: #fff;
          top: calc(100% + 50px);
          position: absolute;
          -webkit-transform: translateX(50%) rotate(-45deg);
          transform: translateX(50%) rotate(-45deg);
        }
        justify-content: space-between;
        padding: 10px 20px;
        color: #7b7b85;
        .date-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 12px;
        }
        .date {
          margin-top: 4px;
        }
        span {
          margin: 0;
          font-size: 16px;
        }
      }
    }

    .calender-active {
      &::after {
        top: calc(100% + 22px);
        opacity: 1;
        visibility: visible;
        transition: 0.5s ease-in-out;
      }
    }
  }
  &__bottom {
    display: block;
    position: fixed;
    width: fit-content;
    height: 0px;
    top: 0;
    left: 0;
    transition: 0.5s ease;
    animation-name: mbsc-anim-p-in;
    animation-duration: 0.5s;
    z-index: 100;
    padding: 0 100px;

    @include min-sm {
      position: absolute;
      top: calc(100% + 28px);
      // left: 50%;
      transform: translateX(-50%);
    }

    &__container {
      width: 100vw;
      left: 0;
      top: 0;
      position: absolute;
      @include min-sm {
        width: 0;
        // position: relative;
        left: 28px;
        min-width: 750px;
      }
    }

    &__container-with-hotel-select {
      @include min-sm {
        left: 100%;
        transform: translateX(-50%);
      }
    }
  }
}
</style>
